import React, { useMemo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { TPropertiesOfPatchChangesForModifiers } from 'types';
import { properties } from 'appConstants/modifiers';
import { MultipleSelect } from './MultipleSelect';
import SelectedItem from 'components/SelectedItem/SelectedItem';
import style from './index.module.scss';

interface IProps {
	setProperties: (value: TPropertiesOfPatchChangesForModifiers[]) => void;
	selectedProperties: TPropertiesOfPatchChangesForModifiers[];
	isCreatedFromPos: boolean;
	hasPortions: boolean;
}

export const PropertiesMultipleSelect: React.FC<IProps> = React.memo(
	({ setProperties, selectedProperties, isCreatedFromPos, hasPortions }) => {
		const { t } = useTranslation('form');

		const fieldsToDisable = new Set(['price', 'supplementPrice']);

		const translatedProperties = useMemo(() => {
			return properties
				.filter((p) => !(isCreatedFromPos || hasPortions) || !fieldsToDisable.has(p.id))
				.map((p) => ({
					id: p.id,
					name: t(p.name),
				}));
		}, [isCreatedFromPos, hasPortions, t]);

		const handleRemove = useCallback(
			(id: string) => {
				const updatedSelectedItems = selectedProperties.filter((el) => el !== id);
				setProperties(updatedSelectedItems);
			},
			[selectedProperties, setProperties],
		);

		const restaurantsList = useMemo(() => {
			return selectedProperties.map((el) => {
				const label = translatedProperties?.find((item) => item.id === el)?.name || '';

				return <SelectedItem key={el} label={label} onDelete={() => handleRemove(el)} />;
			});
		}, [selectedProperties, translatedProperties, handleRemove]);

		return (
			<div className={style.container} data-test="RestaurantsMultipleSelect">
				<MultipleSelect
					setProperties={setProperties}
					properties={translatedProperties}
					selectedProperties={selectedProperties}
				/>
				<div className={style.groupsList}>{restaurantsList}</div>
			</div>
		);
	},
);
